import { useEffect, useState } from 'react';

import { RANKED_ROLES_LIST } from 'bundles/onboarding-common/data/rankedRolesList';
import useGetRolesByIds from 'bundles/onboarding-common/hooks/useGetRolesByIds';
import type { RoleFragment } from 'bundles/onboarding-common/queries/__generated__/RoleFragment';

const useArtificiallyPaginatedRoles = ({
  skip = 0,
  limit = 9,
  skipQuery = false,
}: {
  skip?: number;
  limit?: number;
  skipQuery?: boolean;
}) => {
  const { getRolesByIds } = useGetRolesByIds();
  const [roles, setRoles] = useState<Array<RoleFragment>>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getRoles = async () => {
      const selectedRoleIds = RANKED_ROLES_LIST.slice(skip, skip + limit);

      setLoading(true);
      const { data } = await getRolesByIds({ variables: { ids: selectedRoleIds } });

      setRoles(data?.PathwaySkillCareerRoles?.queryRolesByIds ?? []);
      setLoading(false);
    };

    if (!skipQuery) {
      getRoles();
    } else {
      setLoading(false);
    }
  }, [skip, limit, getRolesByIds, skipQuery]);

  return {
    roles,
    loading,
  };
};

export default useArtificiallyPaginatedRoles;
